const fetch = require('isomorphic-fetch');
const {
  serialize,
  safeEncodeURIComponent
} = require('./serialize');
const BASE_ENDPOINT = 'https://api.airtable.com/v0/';
const createFetch = _ref => {
  let {
    url,
    ...params
  } = _ref;
  return fetch(url, params).then(resp => resp.json());
};
class Airtable {
  constructor() {
    let config = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    const noop = () => {};
    this.log = config.log || noop;
    this.config = config;
  }
  base(ref) {
    this.config.base = ref;
    return this;
  }
  table(ref) {
    this.config.table = ref;
    return this;
  }
  view(ref) {
    this.config.view = ref;
    return this;
  }
  stringify() {
    let params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    const {
      base,
      table,
      view
    } = this.config;
    const merged = {
      maxRecords: 20,
      ...params
    };
    if (view) {
      merged.view = view;
    }
    let url = "".concat(BASE_ENDPOINT).concat(base, "/").concat(safeEncodeURIComponent(table));
    if (Object.keys(merged).length) {
      url += "?".concat(serialize(merged));
    }
    return url;
  }
  list() {
    var _this = this;
    let params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    const {
      apiKey
    } = this.config;
    const req = async function () {
      let accumulator = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
      let offset = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
      console.log(offset);
      const url = _this.stringify({
        ...params,
        offset
      });
      _this.log(url);
      let data = await createFetch({
        url,
        method: 'GET',
        headers: {
          Authorization: "Bearer ".concat(apiKey)
        }
      });
      _this.log(data);
      if (!data || !data.records) {
        return data;
      }
      let {
        records
      } = data;
      if (accumulator) {
        if (records.length) {
          accumulator.records = accumulator.records.concat(records);
        }
      } else {
        accumulator = data;
      }
      if (!data.offset) {
        return accumulator;
      }
      offset = data.offset;
      delete accumulator.offset;
      return req(accumulator, offset);
    };
    return req(null, params.offset || '');
  }
  update(id) {
    let params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    const {
      base,
      table,
      apiKey
    } = this.config;
    const url = "".concat(BASE_ENDPOINT).concat(base, "/").concat(safeEncodeURIComponent(table), "/").concat(id);
    this.log(url);
    return createFetch({
      url,
      method: 'PATCH',
      headers: {
        'Content-type': 'application/json',
        'Authorization': 'Bearer ' + apiKey
      },
      body: JSON.stringify({
        fields: params.fields || params
      })
    });
  }
  retrieve(id) {
    const {
      base,
      table,
      apiKey
    } = this.config;
    const url = "".concat(BASE_ENDPOINT).concat(base, "/").concat(safeEncodeURIComponent(table), "/").concat(id);
    this.log(url);
    return createFetch({
      url,
      method: 'GET',
      headers: {
        'Authorization': 'Bearer ' + apiKey
      }
    });
  }
  delete(id) {
    const {
      base,
      table,
      apiKey
    } = this.config;
    const url = "".concat(BASE_ENDPOINT).concat(base, "/").concat(safeEncodeURIComponent(table), "/").concat(id);
    this.log(url);
    return createFetch({
      url,
      method: 'DELETE',
      headers: {
        Authorization: 'Bearer ' + apiKey
      }
    });
  }
  create(params) {
    const {
      base,
      table,
      apiKey
    } = this.config;
    const url = "".concat(BASE_ENDPOINT).concat(base, "/").concat(safeEncodeURIComponent(table));
    this.log(url);
    return createFetch({
      url,
      method: 'POST',
      headers: {
        'Content-type': 'application/json',
        'Authorization': 'Bearer ' + apiKey
      },
      body: JSON.stringify(params)
    });
  }
  set() {
    return this.update(...arguments);
  }
  get() {
    return this.retrieve(...arguments);
  }
  remove() {
    return this.delete(...arguments);
  }
}
module.exports = Airtable;